/* eslint-disable  */
import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../service/axios/axios'
import './Message.css'
import {format} from 'timeago.js'

function Message({mesgs, own, auth}) {
    const [otherUser, setOtherUser] = useState(null)

    useEffect(() => {
        // MembersMessages entries use member_id/system_user_profile, not sender_id
        if (!mesgs?.sender_id) return;
        const getUser = async () => {
            try {
              const res = await axiosInstance.get(`/users/user?user_id=${mesgs?.sender_id}`)
              setOtherUser(res.data)
            } catch (error) {
                console.log('error', error)
            }
        }
        getUser()
    },[mesgs])

    // For MembersMessages admin replies, use the profile stored on the chat entry
    const otherImage = mesgs?.system_user_profile ?? otherUser?.profile_image ?? '/images/dev/user.png'

  return (
    <div className={`message ${own ? 'own' : ''}`}>
        <div className='messageTop'>
            {own ? (
                <img className='messageImage' src={auth?.user?.profile_image ?? '/images/dev/user.png'} alt="you" />
            ) : (
                <img className='messageImage' src={otherImage} alt="officer" />
            )}
            <div className='messageText'>{mesgs?.message}</div>
        </div>
        <div className='messageBottom'>{format(mesgs?.data ?? mesgs?.created_at ?? new Date())}</div>
    </div>
  )
}

export default Message
